import React from 'react';

import './verticalSeparator.scss';


export const VerticalSeparator = React.memo(() => {
    return <div className={'vertical-separator'}/>;
});
